import { Link, useLocation } from 'react-router-dom';
import { Sheet } from '../ui/Sheet.jsx';
import { useUi } from '../../stores/ui.js';
import { useSession } from '../../stores/session.js';
import { cn } from '../../lib/format.js';
import { useNavLinks } from './useNavLinks.js';

/**
 * The mobile navigation sheet.
 *
 * The same flat list as the desktop bar, from the same source, so the two can
 * never disagree — then order tracking, which matters more on a phone, and the
 * account button. The type mirrors the desktop bar: uppercase, tracked, gold on
 * touch and on the current page.
 */

const rowLink =
  'block px-4 py-3.5 text-xs font-medium tracking-[0.08em] uppercase transition-colors hover:text-brand focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand';

export const MobileNav = () => {
  const open = useUi((state) => state.menuOpen);
  const close = useUi((state) => state.closeMenu);
  const sessionStatus = useSession((state) => state.status);
  const location = useLocation();
  const links = [
    ...useNavLinks(),
    { to: '/orders/track', label: 'Track an order', isActive: ({ pathname }) => pathname === '/orders/track' },
  ];

  return (
    <Sheet open={open} onClose={close} side="left" title="Menu">
      <nav aria-label="Mobile" className="pb-6">
        <ul className="divide-y divide-mist border-b border-mist">
          {links.map((link) => {
            const active = link.isActive(location);

            return (
              <li key={link.to}>
                <Link
                  to={link.to}
                  onClick={close}
                  aria-current={active ? 'page' : undefined}
                  className={cn(rowLink, active ? 'text-brand' : 'text-ink')}
                >
                  {link.label}
                </Link>
              </li>
            );
          })}
        </ul>

        <div className="px-4 pt-6">
          <Link
            to={sessionStatus === 'authenticated' ? '/account' : '/sign-in'}
            onClick={close}
            className="block bg-brand px-5 py-3 text-center text-2xs font-semibold tracking-[0.08em] text-white uppercase transition-colors hover:bg-brand-dark focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
          >
            {sessionStatus === 'authenticated' ? 'Your account' : 'Sign in'}
          </Link>
        </div>
      </nav>
    </Sheet>
  );
};

export default MobileNav;
